<template>
  <div>
    123
  </div>
</template>

<script>
export default {
  name: 'RealTimeScreen',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
</style>
